import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import DevKeyContainer from './modals/DevKeyContainer'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const DevKeyModal = ({orgId, show, toggle}) => {
  const [organization, setOrganization] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await client.get(endpoints.getOrgDetails({ orgId: orgId }))
        setOrganization(resp.data.organization)
      } catch (err) {
        console.log(err)
        toast.error(`There was an error fetching organization data for ID: ${orgId}`)
      }
    }
    fetchData()
  }, [])

  let modalContent = organization ? (
    <DevKeyContainer
      organization={organization}
      setOrganization={setOrganization}
      toggle={toggle}
    />
  ) : (
    <p>Loading ...</p>
  )

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>Dev Key</Modal.Title>
      </Modal.Header>
      <Modal.Body>{modalContent}</Modal.Body>
    </Modal>
  )
}

DevKeyModal.propTypes = {
  orgId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default DevKeyModal
